import PropTypes from 'prop-types';
import React from 'react';
import Skeleton from 'src/components/ui/Skeleton';

const CARD_STYLE = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  border: '1px solid #e1e4e8',
  borderRadius: 12,
  padding: 13,
  marginBottom: 10,
};

const CardSkeleton = ({ avatar, lines, style }) => (
  <div style={{ ...CARD_STYLE, ...style }}>
    <Skeleton width={avatar} height={avatar} style={{ borderRadius: 10, flexShrink: 0 }} />
    <div style={{ flex: 1 }}>
      <Skeleton width={lines[0]} height={14} />
      <Skeleton width={lines[1]} height={11} style={{ marginTop: 7 }} />
    </div>
  </div>
);

CardSkeleton.propTypes = {
  avatar: PropTypes.number,
  lines: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  style: PropTypes.object,
};

CardSkeleton.defaultProps = {
  avatar: 40,
  lines: ['55%', '40%'],
  style: null,
};

export default CardSkeleton;
